"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setup = setup;
exports.pie = exports.default = pie;
exports.runPie = runPie;
exports.doBarAnimation = doBarAnimation;

var _animationHelper = babelHelpers.interopRequireDefault(require("animation-helper"));

var _corePlugin = babelHelpers.interopRequireDefault(require("core-plugin"));

var _promisePolyfill = babelHelpers.interopRequireWildcard(require("promise-polyfill"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

// import $ from 'jquery';
var defaultPieLength = 1500;
var barInitLength = 1500;
var barLength = 100;
var defaultCheckInLength = 750;
var imageNames = ['0.png', 'check.png'].map(function (v) {
  return "/admin/platform/plugins/".concat(_corePlugin.default, "/resources/images/pie/").concat(v);
});
var Images = {};

function loadImages() {
  for (var _len = arguments.length, names = new Array(_len), _key = 0; _key < _len; _key++) {
    names[_key] = arguments[_key];
  }

  var images = names.map(function (image) {
    if (Images[image]) return Images[image];
    return Images[image] = new _promisePolyfill.DelayedPromise(function (resolve) {
      var item = new Image();

      item.onload = function () {
        return resolve(item);
      };

      item.src = image;
    });
  });
  return new _promisePolyfill.DelayedPromise(function (resolve) {
    return resolve(_promisePolyfill.default.all(images));
  });
}

loadImages.apply(void 0, babelHelpers.toConsumableArray(imageNames));

function setup() {
  if (!document.querySelector('style#pieChart')) {
    var S = document.createElement('style');
    S.id = 'pieChart';
    S.textContent = "\n\t\t\thtml.loadedPie > body span[data-pie][class*=pie] {\n\t\t\t\tbackground-image: url(/admin/platform/plugins/".concat(_corePlugin.default, "/resources/images/pie/0.png);\n\t\t\t}\n\t\t\thtml.loadedPie > body span[data-pie][class*=pie].animated {\n\t\t\t\tbackground: transparent none;\n\t\t\t}\n\t\t\thtml.loadedPie > body span[data-pie][class*=pie].animated canvas {\n\t\t\t\tmax-width: 100%;\n\t\t\t\tmax-height: 100%;\n\t\t\t}\n\t\t\thtml.loadedPie > body .progress-container.course .progress-bar .section.complete {\n\t\t\t\tpadding: 0;\n\t\t\t}\n\t\t\thtml.loadedPie > body .progress-container.course .progress-bar .section.complete .bar-item {\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 18px;\n\t\t\t\tposition: relative;\n\t\t\t}\n\t\t\thtml.loadedPie > body .progress-container.course .progress-bar .section.complete .bar-item .bar {\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: -1px;\n\t\t\t\tleft: 0;\n\t\t\t\tbottom: -1px;\n\t\t\t\twidth: 0;\n\t\t\t}\n\t\t");
    document.head.appendChild(S);
    $(document.documentElement).addClass('loadedPie');
  }
}

function pie(element, options) {
  setup();
  options = Object.assign({
    pieLength: defaultPieLength,
    stroke: '#eee',
    strokeWidth: 2,
    fill: '#9c0',
    percent: 'pie' in element.dataset && !isNaN(Number(element.dataset.pie)) ? Number(element.dataset.pie) : 100,
    minPct: 0.04,
    pieDirection: 1,
    noCheck: false,
    checkLength: defaultCheckInLength
  }, options || {});
  var images = imageNames;
  if (options.baseImagePath) images[0] = options.baseImagePath;
  loadImages.apply(void 0, babelHelpers.toConsumableArray(images)).then(function (_ref) {
    var _ref2 = babelHelpers.slicedToArray(_ref, 2),
        defaultImage = _ref2[0],
        checkImage = _ref2[1];

    _classList.default.add(element, 'animated');

    var pie = element,
        canvas = pie.querySelector(':scope > .pie-element');

    if (!canvas) {
      canvas = document.createElement('canvas');
      canvas.className = 'pie-element';
      canvas.width = pie.offsetWidth;
      canvas.height = pie.offsetHeight;
      canvas.style.width = '100%';
      element.appendChild(canvas);
    }

    var context = canvas.getContext('2d');
    context.strokeStyle = options.stroke;
    context.lineWidth = options.strokeWidth;
    context.fillStyle = options.fill;
    context.drawImage(defaultImage, 0, 0, element.offsetWidth, element.offsetHeight);
    var mpX = 0.5 * element.offsetWidth,
        mpY = 0.5 * element.offsetHeight;
    var radius = Math.min(mpX, mpY);
    var piePercent = options.percent;
    piePercent /= 100;
    piePercent = Math.max(options.minPct, piePercent);
    piePercent = Math.min(1, piePercent);
    var radPerPx = radius / (2 * Math.PI); //		var t = { pieElements: [ element ], canvas, context, piePct, s: [mpX,mpY,radius], box: [mpX*2, mpY*2] }

    var pieAnimation = new _animationHelper.default(options.pieLength, 'ease-in-out', function (percent) {
      var pr = 2 * Math.PI * piePercent * percent;
      var pStart, pEnd;
      pStart = 0 - 0.5 * Math.PI;
      pEnd = pr - 0.5 * Math.PI;

      if (options.pieDirection < 0) {
        pEnd = pStart;
        pStart = -1 * pr - 0.5 * Math.PI;
      }

      context.beginPath();
      context.arc(Math.max(0, mpX), Math.max(0, mpY), Math.max(0, radius), pStart, pEnd, false);
      context.lineTo(mpX, mpY);
      context.closePath();
      context.fill();
    }, function () {
      if (!options.noCheck && options.percent == 100) {
        var check = new _animationHelper.default(options.checkLength, 'ease-in-out', function (percent) {
          context.clearRect(0, 0, mpX * 2, mpY * 2);
          context.beginPath();
          context.arc(Math.max(0, mpX), Math.max(0, mpY), Math.max(0, radius), 0, 2 * Math.PI, false);
          context.closePath();
          context.stroke();
          context.fill();
          context.globalAlpha = percent;
          context.drawImage(checkImage, 0, 0, mpX * 2, mpY * 2);
        });
        check.start();
      }
    });
    pieAnimation.start();
  });
}

function runPie() {
  setup();
  var items = document.querySelectorAll('[data-pie]');
  [].forEach.call(items, function (item) {
    return pie(item);
  });
}

function doBarAnimation(target) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : barInitLength;
  setup();
  var bars = target.querySelectorAll('.progress-container.course .progress'),
      allBars = [];
  [].forEach.call(bars, function (barElement) {
    var t = bar.querySelectorAll('.section.complete:not(.init):not(.done)');
    var nodes = [];
    [].forEach.call(t, function (node) {
      node.innerHTML = "<div class='bar-item'><div class='bar'></div></div>";
      var bar = item.querySelector('bar');

      _classList.default.add(item, 'init');

      nodes.push({
        node: node,
        bar: bar
      });
    });
    allBars.push({
      barElement: barElement,
      nodes: nodes
    });
  });
  var barAnimation = new _animationHelper.default(length, 'ease-in-out', function (percent) {
    allBars.forEach(function (_ref3) {
      var barElement = _ref3.barElement,
          nodes = _ref3.nodes;
      var cellPct = 1 / nodes.length,
          x = 0,
          fpct = percent;

      while (cellPct < fpct) {
        nodes[x].bar.style.width = '100%';
        x++;
        fpct -= cellPct;
      }

      if (nodes[x]) nodes[x].bar.style.width = 100 * (fpct / cellPct) + '%';
    });
  }, function () {
    var t = target.querySelectorAll('.progress-container.course .progress .section.complete.init:not(.done)');
    [].forEach.call(t, function (node) {
      return _classList.default.add(node, 'done');
    });
  });
  barAnimation.run();
}